import { useContext } from "react";

import { AnalyticsContext, AnalyticsService } from "./AnalyticsContext";

export const useAnalytics = (): AnalyticsService => {
  return useContext(AnalyticsContext);
};
